export const PME = 0
export const CORP = 1
export const NEW = 2
